import { useCanEdit } from "@/lib/app-context";

export const BONUS_TYPES = ["Festival", "Performance", "Overtime", "Other"];

export function BonusTypeSelect({ value, onChange, testId }) {
  const canEdit = useCanEdit();
  return (
    <select
      value={value || ""}
      disabled={!canEdit}
      onChange={(e) => onChange(e.target.value)}
      className="w-full text-[11px] font-semibold text-slate-600 bg-transparent rounded-md px-1 py-0.5 border border-transparent hover:border-slate-200 focus:border-teal-500 focus:outline-none disabled:opacity-100 disabled:cursor-default"
      data-testid={testId}
    >
      <option value="">{canEdit ? "Type…" : "—"}</option>
      {BONUS_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
    </select>
  );
}

export const bonusLabel = (r) => (r.bonus_type ? `Bonus (${r.bonus_type})` : "Bonus");
